import { API_BASE_URL } from "@/config";
import { validate_form } from "@/utils/signio_validation.js";
import { BANK_CODE_UNIVERSAL } from "@/utils/constants.js";
import { allow_num } from "@/utils/validations";

export default {
  name: 'BankingInfo',
  emits: ["validity-change", "previous"],
  data() {
    return {
      form_data: {
        customerBankAccountBank: '',
        customerBankAccountBranchName: '',
        customerBankAccountHolder: '',
        customerBankAccountNumber: '',
        customerBankAccountType: '',
        customerBankAccountBranchCode: '',
        customerSalaryDay: ''
      },
      bank_list: [
        "ABSA BANK", "AFRICAN BANK", "BANK WINDHOEK", "BIDVEST BANK", "BOE BANK (NEDBANK)", "CAPITEC BANK", "CITIBANK", "FBC FIDELITY BANK LTD", "FIRST NATIONAL BANK", "GRINDROD BANK", "HABIB OVERSEAS BANK", "HBZ BANK", "INVESTEC BANK LIMITED", "MERCANTILE BANK", "MFC", "MTN BANKING (Standard Bank)", "NBS (Nedbank)", "NEDBANK", "NEDBANK (Lesotho)", "NEDBANK (Namibia)", "NEDBANK (Swaziland)", "PEP BANK (NEDBANK)", "PERMANENT BANK", "RESERVE BANK", "SA BANK OF ATHENS", "SA POST OFFICE", "STANDARD BANK", "STANDARD BANK (SWAZILAND)", "STANDARD CHARTERED BANK (20TWENTY)", "STANDARD LESOTHO BANK LIMITED", "UBAN BANK", "Wesbank"
      ],
      account_types: ['Cheque', 'Savings', 'Transmission'],
      days_list: Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0')),
      collapsed_sections: {
        bank_details: false,
        payment_info: false
      }
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  mounted() {
    this.fetch_sygnio_answers();
  },
  methods: {
    allow_num,
    validation_message_creation(message) {
      Swal.fire({
        title: "Field Validation Error",
        text: message,
        icon: "info",
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    },
    validate_banking_information() {
      // Reset validation styles
      $('#customer-bank-account-bank').removeClass('border-danger');
      $('#customer-bank-account-holder').removeClass('border-danger');
      $('#customer-bank-account-number').removeClass('border-danger');
      $('#customer-bank-account-type').removeClass('border-danger');
      $('#customer-salary-day').removeClass('border-danger');

      if (!this.form_data.customerBankAccountBank) {
        this.validation_message_creation("Please select a bank.");
        $('#customer-bank-account-bank').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerBankAccountHolder) {
        this.validation_message_creation("Please enter the account holder's name.");
        $('#customer-bank-account-holder').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerBankAccountNumber) {
        this.validation_message_creation("Please enter the account number.");
        $('#customer-bank-account-number').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerBankAccountType) {
        this.validation_message_creation("Please select the account type.");
        $('#customer-bank-account-type').addClass('border-danger');
        return false;
      }
      if (!this.form_data.customerSalaryDay) {
        this.validation_message_creation("Please select the salary day.");
        $('#customer-salary-day').addClass('border-danger');
        return false;
      }

      return true;
    },
    update_bank_details() {
      const bank = this.form_data.customerBankAccountBank;
      const branch = BANK_CODE_UNIVERSAL.find(b => b.key === bank);
      if (branch) {
        this.form_data.customerBankAccountBranchCode = branch.code;
        this.form_data.customerBankAccountBranchName = branch.branch;
      } else {
        this.form_data.customerBankAccountBranchCode = '';
        this.form_data.customerBankAccountBranchName = '';
      }
    },
    previous() {
      this.$emit("previous");
    },
    toggle(section) {
      this.collapsed_sections[section] = !this.collapsed_sections[section];
    },
    submit_section() {
      const token = localStorage.getItem('token');
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/sygnio_answer/`;
      
      if (!this.validate_banking_information()) {
        return;
      }

      var errors = validate_form(this.form_data);
      if (errors.length > 0) {
        {
          const msg = errors
            .map(err => {
              return `${err.error}`
            })
            .join("\n")

          Swal.fire({
            title: "Validation Error",
            text: msg,
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          })
        }
        return;
      }

      const answers = Object.keys(this.form_data).map(key => ({ 
        answer: this.form_data[key], 
        api_form_field: key 
      }));
      
      $.ajax({
        type: 'POST',
        url: service_api,
        headers: { Authorization: `Token ${token}` },
        data: JSON.stringify({ 
          answers, 
          workflow_id: this.workflow_id 
        }),
        contentType: 'application/json',
        success: response => {
          if (response.status === 'success') {
            Swal.fire({ 
              title: 'Success', 
              text: 'Your information has been submitted successfully!', 
              icon: 'success', 
              timer: 3000, 
              timerProgressBar: true, 
              showConfirmButton: false 
            }).then(() => {
              this.$emit("validity-change", true)
            });
          }
        },
        error: () => {
          Swal.fire({ 
            title: 'Error', 
            text: 'Failed to submit the information, try again later.', 
            icon: 'error', 
            timer: 3000, 
            timerProgressBar: true, 
            showConfirmButton: false 
          });
        }
      });
    },
    fetch_sygnio_answers() {
      const token = localStorage.getItem('token');
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/get_sygnio_question_answers/`;
      
      $.ajax({
        type: 'POST',
        url: service_api,
        headers: {
          Authorization: `Token ${token}`
        },
        data: JSON.stringify({ workflow_id: this.workflow_id }),
        contentType: 'application/json',
        success: (response) => {
          if (response.status === 'success' && response.data) {
            const data = response.data;
            if (Array.isArray(data)) {
              data.forEach(item => {
                const key = item.api_form_field;
                const value = item.answer;
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                }
              });
            } else if (typeof data === 'object') {
              Object.keys(data).forEach(key => {
                const value = data[key];
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                }
              });
            }
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to fetch the answers, please try again later.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
          });
        }
      });
    }
  }
};
